/* istanbul ignore file */
import { SharedCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { Component } from '../../constants/CallbackConstants';
import { doFireStatusUpdate } from '../../utils/CallbackUtils';

// triggered when the BraintreeService.clientInstance is done
/**
 * triggered when the BraintreeService.clientInstance is done
 * @param { BraintreeService } braintreeService
 * @param { React.Dispatch<React.SetStateAction<BraintreeService | undefined> } setService
 */
export var doBraintreeCallback = function doBraintreeCallback(braintreeService, setService) {
  if (braintreeService && braintreeService.clientInstance) {
    setService(braintreeService);
    doFireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: SharedCommandNames.INITIALIZE,
      payload: {
        component: Component.PAYMENT_OPTIONS
      }
    }]);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/braintree/helpers.js
// module id = 4585
// module chunks = 11